const cartInit = () => {
  const cartForm = document.querySelector('.woocommerce-cart-form');
  if (!cartForm) return;

  const clearCouponFeedback = (coupon, removeCoreError = false) => {
    if (coupon) {
      const input = coupon.querySelector('.form-coupon__input');

      coupon.classList.remove('has-error');
      coupon.querySelector('.form-coupon__feedback')?.remove();
      input?.removeAttribute('aria-invalid');
      input?.removeAttribute('aria-describedby');
    }

    if (!removeCoreError) return;

    const coreInput = document.querySelector(
      '.woocommerce-cart-form input[name="coupon_code"]'
    );

    coreInput?.classList.remove('has-error');
    coreInput?.removeAttribute('aria-invalid');
    coreInput?.removeAttribute('aria-describedby');
    document
      .querySelectorAll('.woocommerce-cart-form .coupon-error-notice')
      .forEach((notice) => notice.remove());
  };

  const renderCouponFeedback = (coupon, message) => {
    const content = coupon?.querySelector('.form-coupon__content');
    const input = coupon?.querySelector('.form-coupon__input');
    const toggle = coupon?.querySelector('.form-coupon__toggle');
    const normalizedMessage = message?.trim();

    if (!content || !input || !toggle || !normalizedMessage) return;

    let feedback = coupon.querySelector('.form-coupon__feedback');

    if (!feedback) {
      feedback = document.createElement('p');
      feedback.className = 'form-coupon__feedback';
      feedback.id = 'cart-coupon-error-notice';
      feedback.setAttribute('role', 'alert');
      content.append(feedback);
    }

    feedback.textContent = normalizedMessage;
    coupon.classList.add('has-error');
    input.setAttribute('aria-invalid', 'true');
    input.setAttribute('aria-describedby', feedback.id);
    toggle.setAttribute('aria-expanded', 'true');
    content.hidden = false;
  };

  const syncCouponFeedback = () => {
    const coupon = document.querySelector('[data-coupon-accordion]');
    if (!coupon) return;

    const coreInput = document.querySelector(
      '.woocommerce-cart-form input[name="coupon_code"]'
    );
    const coreError = document.querySelector(
      '.woocommerce-cart-form #coupon-error-notice'
    );

    if (!coreError) {
      clearCouponFeedback(coupon);
      return;
    }

    const input = coupon.querySelector('.form-coupon__input');
    if (input && coreInput?.value) {
      input.value = coreInput.value;
    }

    renderCouponFeedback(coupon, coreError.textContent);
  };

  const updateCount = (delta = 0) => {
    const countEl = document.querySelector('.cart-products-count');
    const mobileCountEl = document.querySelector('.mobile-cart-products-count');
    if (!countEl) return;

    const t = rcTranslate;

    const match = countEl.textContent.match(/\d+/);
    if (!match) return;

    let qty = parseInt(match[0], 10) + delta;
    qty = qty - 1;
    if (qty < 0) qty = 0;

    let label;

    if (qty === 1) {
      label = t.productSingular.replace('%d', qty);
    } else {
      label = t.productPlural.replace('%d', qty);
    }

    document.querySelectorAll('.cart-btn .number').forEach((badge) => {
      if (qty > 0) {
        badge.textContent = qty;
        badge.style.display = '';
      } else {
        badge.textContent = '0';
        badge.style.display = 'none';
      }
    });

    countEl.textContent = label;
    mobileCountEl.textContent = label;
  };

  //REMOVE ITEM
  document.addEventListener('click', (e) => {
    const customRemoveBtn = e.target.closest('.remove_from_cart_button');
    if (!customRemoveBtn) return;

    e.preventDefault();

    const cartItemKey = customRemoveBtn.dataset.cart_item_key;
    if (!cartItemKey) return;

    const originalRemoveBtn = cartForm.querySelector(
      `a.remove[href*="${cartItemKey}"]`
    );

    if (originalRemoveBtn) {
      originalRemoveBtn.click();
    }

    updateCount();
  });

  // COUPON ACCORDION
  document.addEventListener('click', (e) => {
    /* =========================
     * TOGGLE ACCORDION
     * ========================= */
    const toggle = e.target.closest('.form-coupon__toggle');
    if (toggle) {
      const coupon = toggle.closest('[data-coupon-accordion]');
      if (!coupon) return;

      const content = coupon.querySelector('.form-coupon__content');
      if (!content) return;

      const expanded = toggle.getAttribute('aria-expanded') === 'true';

      toggle.setAttribute('aria-expanded', String(!expanded));
      content.hidden = expanded;

      return;
    }

    /* =========================
     * APPLY COUPON
     * ========================= */
    const applyBtn = e.target.closest('.form-coupon__apply');
    if (!applyBtn) return;

    const coupon = applyBtn.closest('[data-coupon-accordion]');
    if (!coupon) return;

    const input = coupon.querySelector('.form-coupon__input');
    if (!input) return;

    const value = input.value.trim();
    if (!value) {
      renderCouponFeedback(coupon, coupon.dataset.couponEmptyMessage);
      input.focus();
      return;
    }

    clearCouponFeedback(coupon, true);

    const cartForm = document.querySelector('.woocommerce-cart-form');
    if (!cartForm) return;

    const realCouponInput = cartForm.querySelector(
      'input[name="coupon_code"]'
    );
    const realApplyBtn = cartForm.querySelector(
      'button[name="apply_coupon"]'
    );

    if (!realCouponInput || !realApplyBtn) return;

    realCouponInput.value = value;
    realApplyBtn.click();
  });

  document.addEventListener('input', (e) => {
    if (!e.target.matches('.form-coupon__input')) return;

    clearCouponFeedback(
      e.target.closest('[data-coupon-accordion]'),
      true
    );
  });

  const syncMobileTotals = () => {
    const mobileTotals = document.querySelector('.mobile-totals');
    if (!mobileTotals) return;

    const newTotal = document.querySelector(
      '.cart_totals .order-total .woocommerce-Price-amount'
    );

    if (!newTotal) return;

    const mobileTotal = mobileTotals.querySelector(
      '.woocommerce-Price-amount'
    );

    if (mobileTotal) {
      mobileTotal.innerHTML = newTotal.innerHTML;
    }
  };

  jQuery(document.body).on(
    'removed_from_cart applied_coupon removed_coupon updated_cart_totals',
    function () {
      setTimeout(function(){
        syncMobileTotals();
      }, 1000)
    }
  );

  jQuery(document.body).on(
    'applied_coupon removed_coupon updated_cart_totals',
    function () {
      setTimeout(syncCouponFeedback, 0);
    }
  );

  syncCouponFeedback();
};

export default cartInit;
